import { createAction } from '@reduxjs/toolkit';
import {
    getReasonOfReturnOptions,
    getStoreAddresses,
    createReturnOrderService,
    getReturnOrdersService
} from '../../services/orderReturnService';

// Action Creators
export const clearOrderReturnMessages = createAction('order/clearMessages');

// --- Return Reason Options ---
export const getReturnReasonStart = createAction('order_return/getReturnReasonStart');
export const getReturnReasonSuccess = createAction('order_return/getReturnReasonSuccess');
export const getReturnReasonFailure = createAction('order_return/getReturnReasonFailure');

export const getStoreAddressesStart = createAction('order_return/getStoreAddressesStart');
export const getStoreAddressesSuccess = createAction('order_return/getStoreAddressesSuccess');
export const getStoreAddressesFailure = createAction('order_return/getStoreAddressesFailure');

export const createReturnOrderStart = createAction('order_return/createReturnOrderStart');
export const createReturnOrderSuccess = createAction('order_return/createReturnOrderSuccess');
export const createReturnOrderFailure = createAction('order_return/createReturnOrderFailure');

// --- Get Return Orders ---
export const getReturnOrdersStart = createAction('order_return/getReturnOrdersStart');
export const getReturnOrdersSuccess = createAction('order_return/getReturnOrdersSuccess');
export const getReturnOrdersFailure = createAction('order_return/getReturnOrdersFailure');



// Thunks
export const getReturnReasonOption = () => async (dispatch) => {
    dispatch(getReturnReasonStart());
    try {
        const response = await getReasonOfReturnOptions();
        if (response.data.status === false) {
            dispatch(getReturnReasonFailure(response.data));
        } else {
            dispatch(getReturnReasonSuccess(response.data));
        }
    } catch (error) {
        dispatch(getReturnReasonFailure(error.message));
    }
};

export const fetchStoreAddresses = () => async (dispatch) => {
    dispatch(getStoreAddressesStart());
    try {
        const response = await getStoreAddresses();
        if (response.data.status === false) {
            dispatch(getStoreAddressesFailure(response.data));
        } else {
            dispatch(getStoreAddressesSuccess(response.data));
        }
    } catch (error) {
        dispatch(getStoreAddressesFailure({ message: error.message }));
    }
};

export const createReturnOrder = (data) => async (dispatch) => {
    dispatch(createReturnOrderStart());
    try {
        const response = await createReturnOrderService(data);
        if (response.data.status === false) {
            dispatch(createReturnOrderFailure(response.data));
        } else {
            dispatch(createReturnOrderSuccess(response.data));
        }
    } catch (error) {
        dispatch(createReturnOrderFailure({ message: error.message }));
    }
};

export const getReturnOrders = (params) => async (dispatch) => {
    dispatch(getReturnOrdersStart());
    try {
        const response = await getReturnOrdersService(params);
        if (response.data.status === false) {
            dispatch(getReturnOrdersFailure(response.data));
        } else {
            dispatch(getReturnOrdersSuccess(response.data));
        }
    } catch (error) {
        dispatch(getReturnOrdersFailure({ message: error.message }));
    }
};